"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCPAndSetZones = void 0;
const effects_1 = require("redux-saga/effects");
const next13_reducers_main_reducer_1 = require("@gerenciatd/next13.reducers.main-reducer");
function* checkCPAndSetZones({ data }) {
    try {
        const { cp, needBussinesZone } = data;
        let module = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require("@gerenciatd/next13.adabyron.geo.get-cp-zone"))));
        module = module.default;
        const lastCP = yield (0, effects_1.select)((state) => state.main.cp);
        const context = yield (0, effects_1.select)((state) => state.main.context);
        // need get again bussinessZones, cuando montamos el modal con datos ya persistidos y no tenmoes la lista de municipios
        if (needBussinesZone) {
            yield (0, effects_1.put)(next13_reducers_main_reducer_1.actions.setCheckedCPByApi(false));
            let response = yield (0, effects_1.call)(module, { cp, context });
            const { businessZones } = response;
            const lastZone = yield (0, effects_1.select)((state) => state.main.zone);
            const lastMunicipio = yield (0, effects_1.select)((state) => state.main.municipio);
            response = {
                cp: lastCP,
                zone: lastZone,
                municipio: lastMunicipio,
                businessZones,
            };
            yield (0, effects_1.put)(next13_reducers_main_reducer_1.actions.setCheckedCPByApi(true));
            yield (0, effects_1.put)(next13_reducers_main_reducer_1.actions.setCpParams(response));
        }
        // regular behaviour
        if (!needBussinesZone && lastCP !== cp) {
            yield (0, effects_1.put)(next13_reducers_main_reducer_1.actions.setCheckedCPByApi(false));
            let response = yield (0, effects_1.call)(module, { cp, context });
            let zone = (response && response.zone) || "ZL";
            let municipio = null;
            // getting first result and using its zone
            if (response &&
                response.businessZones &&
                Array.isArray(response.businessZones) &&
                response.businessZones.length > 0) {
                const { businessZoneName } = response.businessZones[0];
                zone = businessZoneName;
                municipio = response.businessZones[0];
            }
            response = Object.assign(Object.assign({}, response), { cp: response.postalCode, zone,
                municipio });
            delete response.postalCode;
            yield (0, effects_1.put)(next13_reducers_main_reducer_1.actions.setCpParams(response));
            yield (0, effects_1.put)(next13_reducers_main_reducer_1.actions.setCheckedCPByApi(true));
        }
    }
    catch (err) {
        yield (0, effects_1.put)(next13_reducers_main_reducer_1.actions.setCheckedCPByApi(false));
    }
}
exports.checkCPAndSetZones = checkCPAndSetZones;
//# sourceMappingURL=index.js.map